import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef, EventEmitter, Output, Input } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateConverter } from '../../common/service/ngbDateConverter.utils';

@Component({
    selector: 'designerCube',
    templateUrl: 'designerCube.component.html',

})

export class DesignerCube {

    public pageNo: number = 0;
    public pageSize: number = 10;
    public totalCubes: number = 0;
    public sPage: number = 0;
    public cubeReg: string = '';
    public lastRegex: string = '';
    public cubeData: any = { id: null, name: '', description: '', deleted: 0, dataSourceId: null };
    public mainPage: boolean = true;
    public cubePage: boolean = false;
    public datePicker: boolean = false;
    public currentPage: number = 1;
    public selectedCubeId: number;
    public startingPage: number = 0;
    public endingPage: number = 0;
    public entityOpsFlag: boolean = false;
    public cubeList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public dataSourceList: any = [];
    public isEdit: boolean = false;
    public dimensionList: any = [];
    public recordList: any = [];
    public recordObject: any = {};
    public measureList: any = [];
    public measIndex: number = -1;
    public dimInd: number = -1;
    public selectedDim: any;
    public cubeMeasureDataList = [];
    public filteredMeasureMap = new Map();
    public filteredDimensionMap = new Map();
    public measurePage: boolean = false;
    public measureData: any;
    public dimensionPage: boolean = false;
    public dimensionData: any;
    public openDimensionMapping: any;
    public openMeasureMapping: any;
    @Output() emitEdit = new EventEmitter();
    @Output() emitCubeData = new EventEmitter();
    @Input() reload: any;
    public dataVersionType: string = '';


    public recordFormatId: any;

    public cubeDimensionUsageList: any = [];
    public referencevariable: String = 'none';
    public loader: boolean = false;
    public totalPages: number = 0;

    public constructor(public cubeService: MDMService,
                       public toaster: ToasterComponent,
                       public ngbDataConv: NgbDateConverter,
                       public vcr: ViewContainerRef) {
        this.toaster.setViewRef(vcr);
    }

    public dataVersionDate: NgbDateStruct = { day: null, month: null, year: null };

    public ngOnInit() {
        if (this.cubeService.isBIAdmin) {
            this.loadCube();
        }else {
            this.accessDenied = true;
        }
    }

    ngOnChanges() {
        this.onBack();
    }

    public entityOps(event) {
        if (this.selectedCubeId == null) {
            this.selectedCubeId = event.target.id;
        } else {
            this.selectedCubeId = null;
        }
    }

    public closeDropDown(event){
        this.selectedCubeId = null;
    }

    callToaster(type, msg) {
        this.toaster.setViewRef(this.vcr);
        switch (type) {
            case MDMService.ERROR:
                return this.toaster.showError(msg);
            case MDMService.SUCCESS:
                return this.toaster.showSuccess(msg);
            case MDMService.WARNING:
                return this.toaster.showWarning(msg);
        }
    }

    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        this.cubeService.referenceLastPage = this.pageNo;
        if (this.cubeReg != '') {
            this.searchPCube();
        } else {
            this.loadCube();
        }
        this.setEndingPage(this.totalCubes);
    }

    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalCubes / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.cubeService.referencePageSize = this.pageSize;
        this.loadCube();
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = total;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
        self.cubeService.referenceLastPage = Math.floor(self.totalCubes / this.pageSize);
        if (self.totalCubes > self.cubeService.referenceLastPage * this.pageSize) {
            self.cubeService.referenceLastPage += 1;
        }
    }

    public loadCube() {
        let self = this;
        if (self.cubeService.referencePage != undefined) {
            self.pageNo = self.cubeService.referencePage;
            self.currentPage = self.pageNo + 1;
            self.pageSize = self.cubeService.referencePageSize == undefined ? 10 : self.cubeService.referencePageSize;
        }
        return new Promise((resolve) => {
            self.loader = true;
            this.cubeService.getDataByPage(BiUrls.CUBE, self.pageNo, self.pageSize).then((res) => {
                self.cubeList = [];
                self.totalCubes = 0;
                self.totalPages = 0;
                if (res != undefined) {
                    self.cubeList = res.data != undefined &&
                    res.data.pageElements != undefined ? res.data.pageElements : [];
                    self.totalCubes = res.data != undefined &&
                    res.data.total != undefined ? res.data.total : 0;
                }
                self.cubeService.referencePage = null;
                self.parseDataVersionDates();
                self.setEndingPage(self.totalCubes);
                self.loader = false;
                resolve('completed');
            }, (err) => {
                console.error(err);
            });
        });
    }

    public parseDataVersionDates() {
        let self = this;
        for (let cb of self.cubeList) {
            let dv = new Date(cb.dataVersion);
            cb.dataVersion = new Date(dv.getUTCFullYear(), dv.getUTCMonth(), dv.getUTCDate());
        }
    }

    public searchPCube() {
        return new Promise(resolve => {
            let self = this;
            self.mainPage = true;
            self.loader = true;
            self.cubeList = [];
            if (self.cubeReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            } else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.cubeReg;
            let resu = self.cubeService.search(BiUrls.CUBE, BiUrls.SEARCH_P_CUBE,
                self.cubeReg, self.sPage, self.pageSize).then((res) => {
                self.loadSearchedPCube(res);
                self.loader = false;
            }, (err) => {
                console.error(err);
            });
            resolve('completed');
        });
    }

    // By Lalu
    public loadSearchedPCube(res) {
        let self = this;
        self.cubeList = (res != undefined) ? res.data.pageElements : [];
        self.totalCubes = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalCubes);
    }

    public clickEdit(cubeData) {
        let self = this;
        self.loader = true;
        self.selectedCubeId = null;
        self.cubeService.getDataById(BiUrls.EDIT_ANALYTICAL_MODEL, cubeData.id).then((res) => {
            console.log(res.data);
            if (res == undefined || res.data == undefined) {
                self.callToaster(MDMService.ERROR, 'Cannot load Cube');
                self.mainPage = true;
            } else {
                self.mainPage = false;
                self.emitEdit.emit(true);
                self.isEdit = true;
                self.cubeData = JSON.parse(JSON.stringify(res.data));
                console.log(self.cubeData);
                self.cubeMeasureDataList = self.cubeData.cubeMeasureData;
                self.cubeDimensionUsageList = self.cubeData.cubeDimensionUsageData;
                delete self.cubeData.schema;
                delete self.cubeData.facts;
                delete self.cubeData.schemaName;
                delete self.cubeData.status;
                delete self.cubeData.factNames;
                delete self.cubeData.dataSourceName;
                self.cubeService.referencePage = self.pageNo;
                self.emitCubeData.emit(self.cubeData);
            }
            self.loader = false;
        }, (err) => {
            console.error(err);
        });
    }

    public onBack() {
        this.referencevariable = 'none';
        this.mainPage = true;
        this.cubePage = false;
        this.selectedCubeId = null;
        this.isEdit = false;
        this.recordObject = {};
        this.cubeMeasureDataList = [];
        this.filteredMeasureMap.clear();
        this.filteredDimensionMap.clear();
        this.cubeDimensionUsageList = [];
        this.emitEdit.emit(false);
        this.measurePage = false;
        this.dimensionPage = false;
        this.reload = null;
    }

    public deleteModel(cube) {
        let self = this;
        self.loader = true;
        self.cubeService.deleteModel(BiUrls.DELETE_ANALYTICAL_MODEL, cube.id, cube.recordFormatId, cube.dataSourceId).then((res) => {
            if (res.success) {
                self.callToaster(MDMService.SUCCESS, cube.name + ' removed successfully');
            } else if (res.message) {
                self.callToaster(MDMService.ERROR, res.message);
            } else if (res.errorMessage) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            } else {
                self.callToaster(MDMService.ERROR, 'Unable to remove analytical model');
            }
            self.pageNo = self.cubeList.length == 1 ?
                self.totalCubes == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadCube();
            self.loader = false;
        }, (err) => {
            self.callToaster(MDMService.ERROR, 'Unable to remove analytical model : ' + err.errorCode);
        });
    }

    public removeModel(cube) {
        let self = this;
        if (!cube.recordFormatId) {
            self.callToaster(MDMService.ERROR, 'Delete cube directly. No record format associated with this model.');
        } else if (!cube.dataSourceId) {
            self.callToaster(MDMService.ERROR, 'Delete cube directly. No data source associated with this model.');
        } else {
            // let r = confirm('Are you sure you want to delete the cube ' + cube.name + '?');
            let r = false;
            let msg = 'Are you sure you want to delete the cube ' + cube.name;
            if (cube.isStarSchema) {
                r = confirm(msg + '?\nNo dimension will be deleted as it\'s a star schema model.');
            } else {
                r = confirm(msg + '?\nAll dimensions associated with this cube will be deleted.');
            }
            if (r == true) {
                this.deleteModel(cube);
            }
        }
    }

    clearCacheForCube(cube) {
        let self = this;
        self.cubeService.clearCache('ads/clearDataCache/' + cube.id).then((res) => {
            if (res.success) {
                self.callToaster(MDMService.SUCCESS, "Cube Cache cleared successfully!")
            } else {
                self.callToaster(MDMService.ERROR, "Unable To Clear Cube Cache!");
            }
        });
    }

    clearCache() {
        let self = this;
        self.cubeService.clearCache('ads/clearDataCache').then((res) => {
            if (res.success) {
                self.callToaster(MDMService.SUCCESS, "Cache cleared successfully!")
            } else {
                self.callToaster(MDMService.ERROR, "Unable To Clear Cache!");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/pocdesigner/designerCube.component.ts